import React, { useState, useEffect } from 'react';
import './Otp.css';
import { postWithoutTokenAPI } from '../util/Api';
import { useLocation, useNavigate } from 'react-router-dom';
import phone from '../assets/phone1.svg';
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from 'react-redux';
const OTPVerificationforgot = () => {
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [timer, setTimer] = useState(30);
  const navigate = useNavigate();
  const login = useSelector((state) => state.auth?.auth?.access_token);
  const location = useLocation();

  const phone_number = location.state?.phone_number;
  const fromForgotPassword = location.state?.fromForgotPassword;

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer]);

  useEffect(() => {
    if (login) {
      navigate('/user'); // or any page you want
    }
  }, [login, navigate]);
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Move to next input if current input is filled
    if (element.value && element.nextSibling) {
      element.nextSibling.focus();
    }

    return true;
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !e.target.value && e.target.previousSibling) {
      // If backspace is pressed on empty field, move to previous field
      const newOtp = [...otp];
      newOtp[index - 1] = ""; // Clear the previous field
      setOtp(newOtp);
      e.target.previousSibling.focus();
    }
  };

  const handleSubmit = async () => {
    const otpCode = otp.join("");
    setError("");
    setSuccess("");

    if (otpCode.length !== 4) {
      setError("Please enter a valid 4-digit OTP");
      return;
    }

    try {
      const response = await postWithoutTokenAPI("/auth/otpverify", {
        phone_number,
        otp: otpCode,
      });

      if (response.statusCode === 200) {
        toast.success("OTP verified successfully!");

        // Delay navigation to allow the toast to show
        setTimeout(() => {
          navigate("/Forgot", { state: { phone_number, verified: true } });
        }, 2000);
      } else {
        setError(response.message || "OTP verification failed");
      }
    } catch (err) {
      setError("An error occurred. Please try again");
    }
  };


  const handleResend = async () => {
    setError(""); // Reset error message
    try {
      const response = await postWithoutTokenAPI("/auth/otpsendforgot", { phone_number });
      if (response.statusCode === 200) {
        toast.success("OTP resent successfully");
        setOtp(new Array(4).fill(""));
        setTimer(30); // Reset timer to 30 seconds
      } else {
        setError(response.message || "Failed to resend OTP");
      }
    } catch (err) {
      setError("Error while resending OTP. Please try again");
    }
  };

  return (
    <>

      <ToastContainer autoClose={3000} />
      {!login &&
        <div className="otp-container">
          <div className="otp-box">
            <img src={phone} alt="verify" className="otp-icon" />
            <h4>Verify Your Phone number</h4>

            <div className="otp-inputs">
              {otp.map((data, index) => (
                <input
                  type="text"
                  name="otp"
                  maxLength="1"
                  key={index}
                  value={otp[index]}
                  onChange={(e) => handleChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onFocus={(e) => e.target.select()}
                />
              ))}
            </div>

            {error && <div className="otp-error">{error}</div>}
            {success && <div className="otp-success">{success}</div>}

            <button className="otp-verify-btn" onClick={handleSubmit}>Verify</button>

            {timer > 0 ? (
              <p className="otp-resend">Resend Code in <strong>{timer}s</strong></p>
            ) : (
              <p className="otp-resend">
                Didn't receive the code? <span onClick={handleResend} className="otp-resend-link">Resend Code</span>
              </p>
            )}
          </div>
        </div>
      }
    </>
  );
};

export default OTPVerificationforgot;